import { Timestamp, arrayUnion, collection, doc,onSnapshot,orderBy,query,setDoc,where } from "firebase/firestore";
import { useCallback, useEffect, useRef, useState } from "react";
import db from "../Backend";
import { getChapterUnitName, initDB } from "../ConfigureIndexedDB";
import SubFormContent from "./SubFormContent";

const Reportform = () => {
    const entryformat = `Entry format (name, contact, location)\n\n1.kwame ofusu, 0273214456, new town\n
2.kweku sen, 0243457881/0241212909, spintex\n\n3.owusu ntiammoah kese, 0241882341, kasoa`;
    const entryformatkids = `Entry format (name, parent, location)\n\n1.childA, parentA, lapaz\n
2.childB, parentB, spintex\n\n3.childC, parentC, kasoa`;
const expformat = `Entry format (details of expenses, amount)\n\n1.T&T - GHS200\n
2.Miscellaneous - GHS100 \n\n3.Emolument - GHS150`;

    const [username,setUserName]=useState("");
    const [dateofentry,setEntrydate]=useState("");
    const [monthofentry,setEntryMonth]=useState("");
    const [yearofentry,setEntryYear]=useState("");
    const [message,setMessage]=useState("");
    const [unit_name,setUnitName]=useState("");
    const [chapter_name,setChapterName]=useState("");
    const [submittedForms,setFormsSubmitted]=useState([]);
    const [allotments,setAllotmentHistory]=useState([]);
    const [selectedTotals,setSelectedTotals]=useState([]);
    const [grossIncome,setGrossIncome]=useState(0);
    const [monthonfocus,setMonthonfocus]=useState("");
    const [men,setNumbermen]=useState(0);
    const [women,setWomenNumber]=useState(0);
    const [youth,setYouthNumber]=useState(0);
    const [children,setChildren]=useState(0);
    const [tithe,setTithe]=useState(0);
    const [offering,setOffering]=useState(0);
    const [menAttend,setMenattend]=useState("");
    const [womenAttend,setWomenattend]=useState("");
    const [youthAttend,setYOuthattend]=useState("");
    const [childAttend,setChildattend]=useState("");
    const [expenditure,setExpenditure]=useState(0);
    const [expensedetails,setExpdetails]=useState("");
    const [remarks,setRemarks]=useState("");
    const [showLeftbarphone,setShowLeftphonebar]=useState(false);
    const [showRightbarphone,setShowRightbarphone]=useState(false);
    const closeLeftSideRef = useRef();
    const closeRightSidebarRef = useRef();
    const scrollRef = useRef();

    const now = Timestamp.now();
    const dateSent = new Date(now?.toDate()).toUTCString();


    const totalIncome = useCallback(()=>Number(tithe) + Number(offering),[tithe,offering]);
    const totalAttend = useCallback(()=>Number(men)+Number(women)+Number(youth)+Number(children),[men,women,children,youth]);
    const netIncome = useCallback(()=>(totalIncome() - Number(expenditure)),[totalIncome,expenditure]);
    const netmonthproceeds = useCallback(() => Number(grossIncome) - (Number(grossIncome) * 0.70),[grossIncome]);


    const handleSubmitreport=async(e)=>{
        e.preventDefault();
        try{
            await setDoc(doc(db,"weeklyreport",`${dateofentry+unit_name}`),{
                username,
                unit_name,
                chapter_name,
                dateofentry,
                modifieddate: arrayUnion(dateSent),
                monthofentry,
                yearofentry,
                message,
                men,
                women,
                youth,
                children,
                total_attend: `${totalAttend()}`,
                tithe,
                offering,
                expenditure,
                total: `${totalIncome()}`,
                remainingIncome: netIncome(),
                menAttend,
                youthAttend,
                womenAttend,
                childAttend,
                expensedetails,
                remarks
            },{merge: true});
            alert("success");
        }catch(err){
            console.log(err);
        }
    };

    const handleRemittance=async()=>{
        try{
            await setDoc(doc(db,"unitremittances",`${monthonfocus+yearofentry+unit_name}`),{
                unit_name,
                chapter_name,
                total_month_income: grossIncome,
                month_on_focus: monthonfocus,
                amount_alloted: grossIncome * 0.70,
                netproceeds: netmonthproceeds(),
                date_sent: dateSent,
                year: yearofentry,
                username 
            });
            alert("sucess");
        }catch{

        }
    };

    const getStagedTotalincome=(selected_mth,docNum,total_income,ischecked)=>{
        if(ischecked){
            setSelectedTotals(prev => [...prev,{
                total_income,
                docNum
            }]);
            setMonthonfocus(selected_mth);
            
        }else{
            setSelectedTotals(prev => prev.filter(docu => docu.total_income !== total_income && docu.docNum !== docNum));
            setMonthonfocus(selected_mth);
        }
    };

    const editReportDoc=(docdate,docmonth,docyear,docmessage,docoffering,doctithe,docmennum,docwomennum,docyouthnum,docchildrennum,docmendetails,docwomendetails,
        docyouthdetails,docchilddetails,docexpenditure,docexpenddetails,remarks)=>{
            setEntrydate(docdate);
            setEntryMonth(docmonth);
            setEntryYear(docyear);
            setMessage(docmessage);
            setOffering(docoffering);
            setTithe(doctithe);
            setNumbermen(docmennum);
            setWomenNumber(docwomennum);
            setYouthNumber(docyouthnum);
            setChildren(docchildrennum);
            setMenattend(docmendetails);
            setWomenattend(docwomendetails);
            setYOuthattend(docyouthdetails);
            setChildattend(docchilddetails);
            setExpenditure(docexpenditure);
            setExpdetails(docexpenddetails);
            setRemarks(remarks)
    };
    const copyAttendanceDetails=(docmendetails,docwomendetails,docyouthdetails,docchilddetails)=>{
        
            setMenattend(docmendetails);
            setWomenattend(docwomendetails);
            setYOuthattend(docyouthdetails);
            setChildattend(docchilddetails);
            scrollRef.current.scrollIntoView({behavior:"smooth"});
    };

    const handleResetTotals=()=>{
        setSelectedTotals([]);
        setMonthonfocus("");
    };

    useEffect(()=>{
        let sum = 0;
        if(selectedTotals.length > 0){
           sum = selectedTotals.reduce((a,b) => a + Number(b.total_income),0);
        }
        setGrossIncome(sum);
    },[selectedTotals]);
    
    useEffect(()=>{
        const collectionRef = collection(db,"weeklyreport");
        const q = query(collectionRef,where("unit_name","==",unit_name),where("yearofentry","==",yearofentry),orderBy("dateofentry","desc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setFormsSubmitted(firedocs);
        })
        return unsub;
    },[unit_name,yearofentry]);

    useEffect(()=>{
        const collectionRef = collection(db,"unitremittances");
        const q = query(collectionRef,where("unit_name","==",unit_name),where("year","==",yearofentry),orderBy("date_sent","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setAllotmentHistory(firedocs);
        })
        return unsub;
    },[unit_name,yearofentry]);

    useEffect(()=>{
        initDB().then(()=>{
            getChapterUnitName("cun")
            .then((data)=>{
                if(data){
                    setChapterName(data.chapter_name);
                    setUnitName(data.unit_name);
                    setUserName(data.user_name && data.user_name);
                }
            }).catch((err)=>{
                console.log(err);
            });
        }).catch((err)=>{
            console.log(err);
        });

        const currentDate = new Date();
        const availablemonths = ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
        setEntryMonth(availablemonths[currentDate.getMonth()]);
        setEntryYear(currentDate.getFullYear().toString());
        // setEntryYear("2023");
    },[]);
    useEffect(() => {
        const clearLeftSidebar=(e)=>{
            if(!closeLeftSideRef.current.contains(e.target)){
                setShowLeftphonebar(false);
            }
        }
        const clearrightSidebar=(e)=>{
            if(!closeRightSidebarRef.current.contains(e.target)){
                setShowRightbarphone(false);
            }
        }
        document.addEventListener('mousedown',clearLeftSidebar);
        document.addEventListener('mousedown',clearrightSidebar)
        return ()=>{
            document.removeEventListener('mousedown',clearLeftSidebar);
            document.removeEventListener('mousedown',clearrightSidebar);
        }
    },[]);


    return ( 
        <div className="hghreportform">
            <div className="leftformbar">
                <div className="leftformbarcontent">
                    {submittedForms && submittedForms.map(data =>(
                        <SubFormContent 
                            key={data.dateofentry}
                            username={data.username}
                            dateofentry={data.dateofentry}
                            monthofentry={data.monthofentry}
                            yearofentry={data.yearofentry}
                            message={data.message}
                            men = {data.men}
                            women={data.women}
                            youth={data.youth}
                            children={data.children}
                            total_attend={data.total_attend}
                            tithe={data.tithe}
                            offering={data.offering}
                            total={data.total}
                            expenditure={data.expenditure}
                            remainingIncome={data.remainingIncome}
                            expensedetails={data.expensedetails}
                            menAttend={data.menAttend}
                            womenAttend={data.womenAttend}
                            youthAttend={data.youthAttend}
                            childAttend={data.childAttend}
                            oncheckchanged={getStagedTotalincome}
                            oneditclicked={editReportDoc}
                            onCopyAttendClicked={copyAttendanceDetails} 
                            remarks={data.remarks}
                        />
                    ))}
                </div>
            </div>

           <form className="unitreportform flex-column2" onSubmit={handleSubmitreport}>
            <div className="phoneheader">
                <div className="flex-column1" onClick={()=>setShowLeftphonebar(true)}>
                    <h4 style={{color:"white"}}>Copies</h4>
                    <svg
                    viewBox="0 0 24 24"
                    fill="white"
                    height="1.2em"
                    width="1.2em">
                    <path d="M21 11h-3V4a1 1 0 00-1-1H3a1 1 0 00-1 1v14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-6a1 1 0 00-1-1zM5 19a1 1 0 01-1-1V5h12v13c0 .351.061.688.171 1H5zm15-1a1 1 0 01-2 0v-5h2v5z" />
                    <path d="M6 7h8v2H6zm0 4h8v2H6zm5 4h3v2h-3z" />
                    </svg>
                </div>
                
                <div className="flex-column1" onClick={()=>setShowRightbarphone(true)}>
                    <h4 style={{color:"white"}}>Allocation</h4>
                    <svg
                    viewBox="0 0 24 24"
                    fill="white"
                    height="1.2em"
                    width="1.2em">
                    <path d="M11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" />
                    </svg>
                </div>
            </div>

            <div className="flex-row3">
            <h2 style={{color:"white"}}>
               {
                `${unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().split(" ").includes("chapter") 
                    ? 'Chapter Report' 
                    : 'Unit Report'
                }`
               }
            </h2>

            <fieldset>
            <legend>Query</legend>
            <input type="text" value={yearofentry} required onChange={e => setEntryYear(e.target.value)}/>
            </fieldset>
            </div>
        

            <fieldset>
            <legend>Submitted by:</legend>
            <input id="nameinput" type="text" required readOnly value={username} onChange={e => setUserName(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Date of entry</legend>
            <input type="date" value={dateofentry} required onChange={e => setEntrydate(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Month of entry</legend>
            <input type="text" value={monthofentry} required readOnly onChange={e => setEntryMonth(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Year of entry</legend>
            <input type="text" value={yearofentry} required readOnly onChange={e => setEntryYear(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Name of Unit</legend>
            <input type="text" readOnly value={unit_name} required onChange={e => setUnitName(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Name of Chapter</legend>
            <input type="text" readOnly value={chapter_name} required onChange={e => setChapterName(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Message Watched/Book Review</legend>
            <input id="mwinput" type="text" required placeholder="message Title here" value={message} onChange={e => setMessage(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Number of men</legend>
            <input type="number" min={0} max={1000} value={men} required onChange={e => setNumbermen(e.target.value)}/>
            </fieldset>
            
            <fieldset>
            <legend>Number of women</legend>
            <input type="number" min={0} max={1000} value={women} required onChange={e => setWomenNumber(e.target.value)} />
            </fieldset>

            <fieldset>
            <legend>Number of youth</legend>
            <input type="number" min={0} max={1000} value={youth} required onChange={e => setYouthNumber(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Number of children</legend>
            <input type="number" min={0} max={1000} value={children} required onChange={e => setChildren(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Tithe GHS</legend>
            <input type="number" min={0} step={0.01} value={tithe} required onChange={e => setTithe(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Offering GHS</legend>
            <input type="number" min={0} step={0.01} value={offering} required onChange={e => setOffering(e.target.value)}/>
            </fieldset>

            <fieldset>
            <legend>Total Expenses GHS</legend>
            <input type="number" min={0} step={0.01} value={expenditure} required onChange={e => setExpenditure(e.target.value)}/>
            </fieldset>

            <fieldset>
                    <legend>Details of expenses</legend>
                    <textarea id="expensetextarea" rows={10} placeholder={expformat} required value={expensedetails} onChange={e => setExpdetails(e.target.value)}/>
            </fieldset>

            <div className="attendanceform flex-row3" ref={scrollRef}>
                <fieldset>
                    <legend>{`Men attendance from (name, contact, location)`}</legend>
                    <textarea rows={20} placeholder={entryformat} required value={menAttend} onChange={e => setMenattend(e.target.value)}/>
                </fieldset>

                <fieldset>
                    <legend>{`Women attendance from (name, contact, location)`}</legend>
                    <textarea rows={20} placeholder={entryformat} required value={womenAttend} onChange={e => setWomenattend(e.target.value)}/>
                </fieldset>

                <fieldset>
                    <legend>{`Youth attendance from (name, contact, location)`}</legend>
                    <textarea rows={20} placeholder={entryformat} required value={youthAttend} onChange={e => setYOuthattend(e.target.value)}/>
                </fieldset>

                <fieldset>
                    <legend>{`Children attendance from (name, parent, location)`}</legend>
                    <textarea rows={20} placeholder={entryformatkids} required value={childAttend} onChange={e => setChildattend(e.target.value)}/>
                </fieldset>
            </div>

            <fieldset>
                    <legend>Remarks/Comment</legend>
                    <textarea id="remarkstextarea" rows={10} placeholder="write a short note about this report." 
                    required value={remarks} onChange={e => setRemarks(e.target.value)}/>
            </fieldset>

            <button>Submit Report</button>
           </form>

           <div className="rightformbar">
            <div className="rightformbarcontent flex-column1">
            <h3>70% payable: {parseFloat(grossIncome * 0.70).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h3>

            <div className="flex-row2">
                <h4>Month</h4>
                <input type="text" value={monthonfocus} readOnly onChange={e => setMonthonfocus(e.target.value)} />
            </div>

            {selectedTotals && selectedTotals.map(data => (
                <div className="flex-row3" style={{gap:"3px"}}>
                    <h4>{`Income on ${data.docNum && data.docNum}:`}</h4>
                    <p style={{color:"orangered",fontWeight:"bold"}}>
                        {`GHS ${data.total_income && data.total_income}`}
                    </p>
                </div>
                
            ))
            }

            <div className="flex-row2" style={{gap:"10px"}}>
            <button onClick={handleRemittance}>Allocate</button>
            <button onClick={handleResetTotals}>Reset</button>
            </div>
           
            <h4>Total Income:{parseFloat(grossIncome).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'})}
            </h4>   <br/>

            <h3>Statement of account {yearofentry}:</h3>

            {allotments && allotments.map(data => (
            <div className="flex-column2" style={{gap:"5px",marginBottom:"2em"}} key={data.date_sent}>
                    <h3 style={{borderBottom:"1px solid black"}}>{data.month_on_focus}</h3>
                    <h4>{`Total Inflows: ${parseFloat(data.total_month_income).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                    <h4>{`Ammount alloted: ${parseFloat(data.amount_alloted).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                    <h4>{`Net(Surplus/at par): ${parseFloat(data.netproceeds).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
           </div>
            ))}
            
            </div>
            </div>

           <div className={`leftformbar-phone ${showLeftbarphone ? 'open' : 'close'}`} ref={closeLeftSideRef}>
                <div className="leftformbarcontent">
                    {submittedForms && submittedForms.map(data =>(
                        <SubFormContent 
                            key={data.dateofentry}
                            username={data.username}
                            dateofentry={data.dateofentry}
                            monthofentry={data.monthofentry}
                            yearofentry={data.yearofentry}
                            message={data.message}
                            men = {data.men}
                            women={data.women}
                            youth={data.youth}
                            children={data.children}
                            total_attend={data.total_attend}
                            tithe={data.tithe}
                            offering={data.offering}
                            total={data.total}
                            expenditure={data.expenditure}
                            remainingIncome={data.remainingIncome}
                            expensedetails={data.expensedetails}
                            menAttend={data.menAttend}
                            womenAttend={data.womenAttend}
                            youthAttend={data.youthAttend}
                            childAttend={data.childAttend}
                            oncheckchanged={getStagedTotalincome}
                            oneditclicked={editReportDoc}
                            onCopyAttendClicked={copyAttendanceDetails} 
                            remarks={data.remarks}
                        />
                    ))}
                </div>
            </div>

            <div className={`rightformbar-phone ${showRightbarphone ? 'open' : 'close'}`} ref={closeRightSidebarRef}>
            <div className="rightformbarcontent flex-column1">
            <h3>70% payable: {parseFloat(grossIncome * 0.70).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h3>

            <div className="flex-row2">
                <h4>Month</h4>
                <input type="text" value={monthonfocus} readOnly onChange={e => setMonthonfocus(e.target.value)} />
            </div>

            {selectedTotals && selectedTotals.map(data => (
                <div className="flex-row3" style={{gap:"3px"}}>
                    <h4>{`Income on ${data.docNum && data.docNum}:`}</h4>
                    <p style={{color:"orangered",fontWeight:"bold"}}>
                        {`GHS ${data.total_income && data.total_income}`}
                    </p>
                </div>
                
            ))
            }

            <div className="flex-row2" style={{gap:"10px"}}>
            <button onClick={handleRemittance}>Allocate</button>
            <button onClick={handleResetTotals}>Reset</button>
            </div>
           
            <h4>Total Income:{parseFloat(grossIncome).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'})}
            </h4>   <br/>

            <h3>Statement of account:</h3>

            {allotments && allotments.map(data => (
            <div className="flex-column2" style={{gap:"5px",marginBottom:"2em"}} key={data.date_sent}>
                    <h3 style={{borderBottom:"1px solid black"}}>{data.month_on_focus}</h3>
                    <h4>{`Total Inflows: ${parseFloat(data.total_month_income).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                    <h4>{`Ammount alloted: ${parseFloat(data.amount_alloted).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
                    <h4>{`Net(Surplus/at par): ${parseFloat(data.netproceeds).toLocaleString('en-US',{style:"currency",currency:"GHS"})}`}</h4>
           </div>
            ))}
            
            </div>
           </div>

        </div>
     );
}
export default Reportform;